import { render, staticRenderFns } from "./ResearchInnovationReviewCouncilSave.vue?vue&type=template&id=6e2f8304&"
import script from "./ResearchInnovationReviewCouncilSave.vue?vue&type=script&lang=js&"
export * from "./ResearchInnovationReviewCouncilSave.vue?vue&type=script&lang=js&"
import style0 from "./ResearchInnovationReviewCouncilSave.vue?vue&type=style&index=0&id=6e2f8304&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports